import "./CardProject.css";

import ProjectItem from "../ProjectItem/ProjectItem";

const CardProject = (props) => {
	const datas = props.data;
	const tabs = props.tab;
	return (
		<div className="tab-content project-tab">
			{tabs.map((tab, key) => (
				<div className={`tab-pane ${key === 0 ? "active show" : ""}`} id={tab.tabLink} key={key}>
					<div className="d-flex flex-wrap justify-content-between project-content">
						{datas
							.filter((data) => data.category === tab.tabLink)
							.map((data, key) => (
								<ProjectItem key={key} {...data} />
							))}
					</div>
				</div>
			))}
		</div>
	);
};
export default CardProject;
